// ---------------------------------------------------------

import dynamic from 'next/dynamic';

// ---------------------------------------------------------

const Accordion = dynamic(() => import('@components/accordion'));
const AgentFinder = dynamic(() => import('@components/agent-finder'));
const ArticleCard = dynamic(() => import('@components/article-card'));
const Button = dynamic(() => import('@components/button'));
const BuysideWidget = dynamic(() => import('@components/buyside-widget'));
const Category = dynamic(() => import('@components/category'));
const Container = dynamic(() => import('@layout/container'));
const FeaturedContent = dynamic(() => import('@components/featured-content'));
const Form = dynamic(() => import('@components/forms'));
const Grid = dynamic(() => import('@layout/grid'));
const Image = dynamic(() => import('@components/image/block-image'));
const Input = dynamic(() => import('@components/inputs/input'));
const Jumbotron = dynamic(() => import('@components/jumbotron'));
const PostList = dynamic(() => import('@components/post-list'));
const Quad = dynamic(() => import('@components/quad'));
const Select = dynamic(() => import('@components/select'));
const SellWithSibcy = dynamic(() => import('@components/sell-with-sibcy'));
const TextBlock = dynamic(() => import('@components/text-block'));
const Video = dynamic(() => import('@components/video'));

// ---------------------------------------------------------

export default {
  Accordion,
  AgentFinder,
  ArticleCard,
  Button,
  BuysideWidget,
  Category,
  Container,
  Form,
  Grid,
  Image,
  Input,
  Jumbotron,
  PostBlogCategory: Category,
  PostList,
  Quad,
  Select,
  SellWithSibcy,
  TextBlock,
  TopicPage: FeaturedContent,
  TopicRecord: FeaturedContent,
  Video
};
